var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsNotEmpty, IsString, MaxLength } from 'class-validator';
/** Body of the actions that require a stated reason: reversing a Zahlung, an Ausbuchung, and its reversal. */
export class PatientInvoiceReasonDto {
    reason;
}
__decorate([
    IsString(),
    IsNotEmpty(),
    MaxLength(512),
    __metadata("design:type", String)
], PatientInvoiceReasonDto.prototype, "reason", void 0);
//# sourceMappingURL=patient-invoice-reason.dto.js.map